export function jobPrint() {
    // By selecting .pul-job-detail-title
    // I'm checking if we are on job detail page
    const ifJobPage = document.querySelector(".pul-job-detail-title");

    if (ifJobPage) {
        const contactPersonImg = document.querySelector(".pul-contact__detail>img");

        if (contactPersonImg) {
            // remove lazy loading from contact person image
            // because it is not displayed when printing page
            contactPersonImg.removeAttribute("loading");
        }
    }
}
